<template>
  <div class="page-wrapper chiller-theme" id="main">
    <main-sidebar></main-sidebar>
    <main class="page-content">
      <main-header></main-header>
      <user-data v-if="selectedTab === 'users'" :has-permission="hasPermission"></user-data>
      <role-data v-else-if="selectedTab === 'roles'" :has-permission="hasPermission"></role-data>
    </main>
  </div>
</template>

<script>
  import MainHeader from './../layout/MainHeader.vue'
  import MainSidebar from './../layout/MainSidebar.vue'
  import UserData from './UserData.vue'
  import RoleData from './RoleData.vue'

  export default {
    name: 'users',
    components: {
      MainHeader,
      MainSidebar,
      UserData,
      RoleData
    },
    data() {
      return {}
    },
    mounted() {
      // this.$store.commit('selectedTab', 'users');
    },
    methods: {},
    computed: {
      currentComponent() {
        return this.selectedTab === 'users' ? 'UserData' : 'RoleData';
      },
      selectedTab() {
        return this.$store.getters.selectedTab;
      },
      hasPermission() {
        return (name) => {
          const perms = this.$store.getters.userPermissions || []
          console.log("stif|perms:", perms)
          if (perms.length === 0) return false
          if (typeof perms[0] === 'string') {
            return perms.includes(name)
          }
          return false
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/users/Index.vue